const getRestrictedUserIds = () => {
  const restrictedUserIdsString = process.env.REACT_APP_RESTRICTED_USER_IDS;

  if (!restrictedUserIdsString) {
    console.warn(
      "Restricted User Ids not found. Please set the environment variable REACT_APP_RESTRICTED_USER_IDS."
    );
  }

  return restrictedUserIdsString ? restrictedUserIdsString.split(",") : [];
};

export const isUserRestricted = (userId: string) => {
  const restrictedUserIds = getRestrictedUserIds();
  return restrictedUserIds.includes(userId);
};
